import React from 'react';
import { translate } from 'react-i18next';
import Payment from './Payment';
import '../../Dashboard/Dashboard.css';

class Dashboard extends React.Component {

  render() {
    const boxStyle = {
      boxSizing: 'border-box',
      minWidth: '400px',
      minHeight: '400px',
      display: 'flex',
      flexGrow:'1',
      position: 'relative',
      border:'1px solid #e9e9e9',
      borderRadius: '5px',
      padding: '5px',
      margin: '5px'
    };

    const tabProps = {
      boxStyle
    };


    return (
      <div className='dashboardDiv'>
        <Payment {...tabProps}/>
      </div>
    );
  }
}

export default translate()(Dashboard);



// WEBPACK FOOTER //
// ./src/Admin/Dashboard/Dashboard.js